import { Amplify } from "aws-amplify";
import { post } from "aws-amplify/api";
import outputs from "../amplify_outputs.json";

const emailApiEndpoint =
  process.env.REACT_APP_EMAIL_API_ENDPOINT ||
  process.env.REACT_APP_EMAIL_API_URL ||
  "https://bt9f6kly45.execute-api.us-east-1.amazonaws.com/prod";

const pendingNotifications = new Map();
const recentlySentNotifications = new Map();
const duplicateWindowMs = 60_000;

function getNotificationKey({ to, subject, body, buttonUrl, buttonText }) {
  return JSON.stringify([
    String(to || "")
      .trim()
      .toLowerCase(),
    subject || "",
    body || "",
    buttonUrl || "",
    buttonText || "",
  ]);
}

function configureEmailApi() {
  const currentConfig = Amplify.getConfig();
  // amplify-config.js already registers this at app startup; re-configuring
  // Amplify on every send can race with in-flight requests and cause
  // duplicate/retried invocations, so only configure if it's missing.
  if (currentConfig.API?.REST?.emailapi) return;

  Amplify.configure({
    ...currentConfig,
    API: {
      ...currentConfig.API,
      REST: {
        ...currentConfig.API?.REST,
        emailapi: {
          endpoint: emailApiEndpoint.replace(/\/+$/, ""),
          region: outputs.auth.aws_region,
          authorizationType: "AWS_IAM",
        },
      },
    },
  });
}

export async function postEmailNotification(payload) {
  const notificationKey = getNotificationKey(payload);
  const sentAt = recentlySentNotifications.get(notificationKey);
  if (sentAt && Date.now() - sentAt < duplicateWindowMs) {
    return { deduplicated: true };
  }

  const pendingNotification = pendingNotifications.get(notificationKey);
  if (pendingNotification) return pendingNotification;

  configureEmailApi();
  const notification = (async () => {
    const operation = post({
      apiName: "emailapi",
      path: "/sendConnectionEmail",
      options: { body: payload },
    });
    const { body } = await operation.response;
    const response = await body.json();
    recentlySentNotifications.set(notificationKey, Date.now());
    return response;
  })();

  pendingNotifications.set(notificationKey, notification);
  try {
    return await notification;
  } finally {
    pendingNotifications.delete(notificationKey);
  }
}
